export default "__VITE_ASSET__KlCL6R5V__"